import { loginUser, resetPasswordForEmail } from '../api/auth.js';
import { fetchWallets } from '../api/wallets.js';

export function initAuthComponent(onLoginSuccess) {
    const loginForm = document.getElementById('login-form');
    const loginScreen = document.getElementById('login-screen');
    const mainApp = document.getElementById('main-app');
    const btnLogin = document.getElementById('btn-login');
    const loginError = document.getElementById('login-error');

    if (!loginForm) return;

    loginForm.addEventListener('submit', async (e) => {
        e.preventDefault(); // Ngăn trình duyệt tải lại trang
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        
        btnLogin.innerText = "Authenticating...";
        btnLogin.disabled = true;

        const res = await loginUser(email, password);
        
        if (res.success) {
            loginScreen.classList.add('hidden');
            mainApp.classList.remove('hidden');
            mainApp.classList.add('flex');
            
            // Invoke the callback that initializes the rest of the application
            if(onLoginSuccess) await onLoginSuccess();
            
        } else {
            loginError.innerText = "Login failed: " + res.message;
            loginError.classList.remove('hidden');
        }
        btnLogin.innerText = "Login";
        btnLogin.disabled = false;
    });

    const btnForgot = document.getElementById('btn-forgot-pwd');
    if (btnForgot) {
        btnForgot.addEventListener('click', async () => {
            const email = document.getElementById('email').value;
            if (!email || !email.includes('@')) {
                loginError.innerText = "Please enter your email address above first to reset password.";
                loginError.classList.remove('hidden');
                return;
            }
            
            btnForgot.innerText = 'Sending...';
            btnForgot.disabled = true;

            const res = await resetPasswordForEmail(email);

            btnForgot.innerText = 'Forgot Password?';
            btnForgot.disabled = false;

            if (res.success) {
                loginError.classList.remove('text-expense');
                loginError.classList.add('text-income');
                loginError.innerText = "Password reset email sent! Check your inbox.";
                loginError.classList.remove('hidden');
            } else {
                loginError.classList.remove('text-income');
                loginError.classList.add('text-expense');
                loginError.innerText = "Reset failed: " + res.message;
                loginError.classList.remove('hidden');
            }
        });
    }
}
